import useWhitelist from './useWhitelist'

export default useWhitelist
